import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { injectIntl } from "react-intl"
import Text from "../text"
import Box from "../../lib/ui/ui-box"
import { Colors } from "../../lib/theme"

const Root = styled(Box)`
  min-height: 110px;
  height: auto;
  position: relative;
  border-radius: 0;
  border-left: 1px solid ${Colors.actionPrimary};
`

const Number = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-10px) translateX(-20px);
  width: 40px;
  height: 40px;
  background-color: white;
  border: 1px solid ${Colors.actionPrimary};
  border-radius: 5000px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const Check = styled.img`
  flex-shrink: 0;
  width: 19px;
  height: 19px;
`

const Step = props => {
  return (
    <Root w={["100%", "100%", "100%", "100%"]} pb={[3]}>
      <Number>
        <Text fontSize={[2]} color="actionPrimary" fontWeight="700">
          {props.number}
        </Text>
      </Number>
      <Box
        flexDirection={["column", "column", "column", "row"]}
        justify="space-between"
        w="100%"
      >
        <Box
          flexDirection="column"
          pl={[4, 2, 4]}
          mb={[2, 2, 0]}
          flex={["auto", "auto", "auto", "auto"]}
        >
          {/* Title */}
          <Box w={["100%", "100%", "552px"]} mb={[2]}>
            <Text
              color="#535353"
              fontSize={[2, 2, 2]}
              lineHeight={[2, 2, 2]}
              fontWeight="700"
            >
              {props.title()}
            </Text>
          </Box>
          {/* Description */}
          <Box w={["100%", "100%", "552px"]}>
            <Text
              color="#535353"
              fontSize={[1, 1, 1]}
              lineHeight={[1, 1, 1]}
              fontWeight="100"
            >
              {props.description}
            </Text>
          </Box>

          {props.benefits.map(b => {
            return (
              <Box mt={[2]} w={["100%", "100%", "100%"]} key={b.title}>
                <Text style={{ display: "flex", "flex-shrink": "0" }}>
                  <Check src="./images/landing/check.png" />
                </Text>
                <Text
                  color="#535353"
                  fontSize={[1, 1, 2]}
                  lineHeight={[1, 1, 2]}
                  ml={[1, 1, 1]}
                >
                  {b.title()}
                </Text>
              </Box>
            )
          })}
        </Box>
      </Box>
    </Root>
  )
}

Step.propTypes = {
  number: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  benefits: PropTypes.arrayOf(
    PropTypes.shape({ title: PropTypes.string.isRequired })
  ).isRequired,
  perks: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.func.isRequired
    })
  ).isRequired
}

export default injectIntl(Step)



// WEBPACK FOOTER //
// ./src/components/step-block/step-block.component.js